import { makeAutoObservable } from 'mobx';
import { validateLossLimit } from './validateLossLimit';

export class LossLimitData {
  lossLimitMode = 'AMOUNT';
  amount = 0;
  /** Unit for amount when lossLimitMode=AMOUNT. Only shown/used for futures. */
  valueUnit = 'DOLLARS';

  constructor(initialData) {
    makeAutoObservable(this);
    if (initialData) {
      Object.keys(initialData).forEach((field) => {
        if (field === 'amount' && initialData.lossLimitMode === 'PERCENT') {
          this.amount = initialData.amount * 100;
        } else {
          this[field] = initialData[field];
        }
      });
    }
  }

  //common methods
  resetToDefaults = () => {
    this.lossLimitMode = 'AMOUNT';
    this.amount = 0;
    this.valueUnit = 'DOLLARS';
  };
  updateTactic = (dataObj) => {
    for (const key in dataObj) {
      this[key] = dataObj[key];
    }
  };
  validate = () => {
    const result = validateLossLimit(this.amount);
    return result;
  };
  returnJson = () => {
    return {
      amount:
        this.lossLimitMode === 'PERCENT'
          ? Number(this.amount) / 100
          : this.amount,
      lossLimitMode: this.lossLimitMode,
      valueUnit: this.valueUnit,
    };
  };

  //specific methods
  setLossLimitMode = (string) => {
    this.lossLimitMode = string;
  };
  setAmount = (number) => {
    this.amount = number;
  };
  setValueUnit = (unit) => {
    this.valueUnit = unit;
  };
}
